module.exports = __webpack_public_path__ + "img/home-ipad_cn.367c2a1.jpg";